module.exports = __webpack_public_path__ + "static/media/logo.d843f6a4.svg";